import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-insufficient-dialog",
  templateUrl: "./insufficient-dialog.component.html",
  styleUrls: ["./insufficient-dialog.component.scss"],
})
export class InsufficientDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<InsufficientDialogComponent>,
  ) {}
  close() {
    this.dialog.close();
  }
}
